const N=v=>v==null||v===''?null:Number.isFinite(Number(v))?Number(v):null;
const avg=a=>a.length?a.reduce((s,x)=>s+x,0)/a.length:null;
const median=a=>{if(!a.length)return null;const s=[...a].sort((x,y)=>x-y),m=Math.floor(s.length/2);return s.length%2?s[m]:(s[m-1]+s[m])/2};

function genuineState(g){
 const p5=N(g?.price_impact_5m_pct),p1=N(g?.price_impact_1m_pct),gap=N(g?.gap_frequency_20d_pct);
 const impact=p5??p1;
 if(impact==null&&gap==null)return'VERIFIED_SNAPSHOT';
 if((impact!=null&&impact>=5)||(gap!=null&&gap>=20))return'HIGH_ELASTICITY';
 if((impact!=null&&impact>=2)||(gap!=null&&gap>=10))return'ELEVATED_ELASTICITY';
 return'LOWER_ELASTICITY';
}

export function deriveGrasshopperEvidence(bundle={}){
 const g=bundle?.grasshopper||{};
 if(String(g?.verification_status||'').toUpperCase()==='VERIFIED'){
  return{
   status:'EVIDENCE',
   state:genuineState(g),
   evidenceType:'INTRADAY_VERIFIED',
   priceImpact1mPct:N(g.price_impact_1m_pct),
   priceImpact5mPct:N(g.price_impact_5m_pct),
   gapFrequency20dPct:N(g.gap_frequency_20d_pct),
   bidAskSpreadBps:N(g.bid_ask_spread_bps),
   avgDailyValue20d:N(g.avg_daily_value_20d),
   medianDailyValue20d:N(g.median_daily_value_20d),
   avgTurnoverPct20d:null,
   maxAbsDailyMovePct20d:null,
   liquidityBand:'VERIFIED_INTRADAY',
   turnoverBand:'MISSING',
   shockBand:'MISSING',
   note:'Grasshopper uses the verified intraday/float snapshot when available. This supersedes the daily fallback proxy.'
  };
 }

 const rows=(Array.isArray(bundle?.market?.rows)?bundle.market.rows:[]).slice(0,21).map(r=>({close:N(r?.close),volume:N(r?.volume)})).filter(r=>r.close!=null&&r.close>0&&r.volume!=null&&r.volume>=0);
 const shares=N(bundle?.secFinancials?.metrics?.sharesOutstanding);
 if(rows.length<10||shares==null||shares<=0)return{status:'MISSING',state:'MISSING',evidenceType:'MISSING',note:'Grasshopper needs a verified intraday snapshot or at least 10 daily price/volume rows plus SEC shares outstanding.'};

 const daily=rows.slice(0,20),dollarValues=daily.map(r=>r.close*r.volume),turnovers=daily.map(r=>r.volume/shares*100);
 const absMoves=[];for(let i=0;i<Math.min(20,rows.length-1);i++){const a=rows[i].close,b=rows[i+1].close;if(a!=null&&b!=null&&b>0)absMoves.push(Math.abs(a/b-1)*100)}
 const avgDailyValue20d=avg(dollarValues),medianDailyValue20d=median(dollarValues),avgTurnoverPct20d=avg(turnovers),maxAbsDailyMovePct20d=absMoves.length?Math.max(...absMoves):null;
 const liquidityBand=avgDailyValue20d>=100e6?'DEEP':avgDailyValue20d>=25e6?'MODERATE':avgDailyValue20d>=5e6?'LIGHT':'THIN';
 const turnoverBand=avgTurnoverPct20d>=1?'HIGH':avgTurnoverPct20d>=0.25?'MODERATE':'LOW';
 const shockBand=maxAbsDailyMovePct20d==null?'MISSING':maxAbsDailyMovePct20d>=8?'HIGH':maxAbsDailyMovePct20d>=4?'ELEVATED':'NORMAL';
 let state='MIXED_DAILY_PROXY';
 if(['THIN','LIGHT'].includes(liquidityBand)&&['HIGH','ELEVATED'].includes(shockBand))state='ELASTICITY_RISK_PROXY';
 else if(['THIN','LIGHT'].includes(liquidityBand)||turnoverBand==='LOW')state='TIGHT_LIQUIDITY_PROXY';
 else if(liquidityBand==='DEEP'&&shockBand==='NORMAL')state='DEEP_LIQUIDITY_PROXY';

 return{
  status:String(bundle?.market?.status||'').toUpperCase()==='VERIFIED'?'EVIDENCE':'STALE_PROXY',
  state,
  evidenceType:'DAILY_LIQUIDITY_PROXY',
  priceImpact1mPct:null,
  priceImpact5mPct:null,
  gapFrequency20dPct:null,
  bidAskSpreadBps:null,
  avgDailyValue20d,
  medianDailyValue20d,
  avgTurnoverPct20d,
  maxAbsDailyMovePct20d,
  liquidityBand,
  turnoverBand,
  shockBand,
  note:'Grasshopper daily proxy uses price/volume, turnover versus SEC shares outstanding, and daily price shocks. It is not an intraday 1m/5m price-impact measurement and must not be presented as one.'
 };
}
